import Debug from '@/components/Debug';
import { Pharmacy } from '@/types/medication';
import Card from '@/ui/components/Card';
import Heading from '@/ui/components/Heading';
import usFormatPhoneNumber from '@/utils/usFormatPhoneNumber';
const PharmacyCard = ({ pharmacy }: { pharmacy: Pharmacy }) => {
  return (
    <Card className="p-4 hover:shadow-lg transition-shadow">
      <div className="flex justify-between items-start mb-3">
        <Heading className="text-lg font-semibold text-gray-900" text={pharmacy.name} />
      </div>
      <dl className="space-y-1 text-sm text-gray-600">
        <div>
          <dt className="font-medium inline">Address:</dt>
          <dd className="inline ml-1 font-bold">
            {pharmacy.address1}
            {pharmacy.address2 ? `, ${pharmacy.address2}` : ''}
            {`, ${pharmacy.city}, ${pharmacy.state} ${pharmacy.postal_code}`}
          </dd>
        </div>
        <div>
          <dt className="font-medium inline">Phone:</dt>
          <dd className="inline ml-1 font-bold">{usFormatPhoneNumber(pharmacy.phone_number)}</dd>
        </div>
      </dl>

      <Debug object={pharmacy as object} />
    </Card>
  );
};

export default PharmacyCard;
